import React from 'react';
import LogoPNG from './logo-2.png';

const Logo = ({styles, className}) => {
    return (
        <img src={LogoPNG} style={styles} className={className} alt="Logo" />
    )
}

export default Logo;